<template>
    <div class="tabs-container" :class="customClass">
        
        <ul class="nav nav-tabs" :class="navTabsClass">
            <div class="container d-flex center-list p-0">
                <li
                    v-for="(tab, index) in tabs"
                    :key="index"
                    :class="'nav-item '+(navItemClass ? ` ${navItemClass}` :'')+(tab.is_active ? ' active' : '')"
                >
                    <a
                        class="nav-link"
                        :class="{ 'active': tab.is_active }"
                        :href="tab.href"
                        @click="selectTab(tab)"
                        v-html="tab.name"
                    >
                    </a>
                </li>
            </div>
        </ul>

        <slot name="sublevel"></slot>

        <div class="tab-content" :class="tabContentClass">
            <div
                class=""
                role="tabpanel"
            >
                <slot name="tabs-content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            customClass: { required: false },
            tabContentClass: { required: false },
            navTabsClass: { required: false },
            navItemClass: { 
                type: String,
                default:'',
            },
        },

        data() {
            return {
                componentKey: 0,
                tabs: []
            }
        },

        created() {
            this.tabs = this.$children
        },

        methods: {
            forceRerender() {
                this.componentKey += 1
            },

            selectTab(selected_tab) {
                if (selected_tab.href) {
                    isLoading()
                }
                this.tabs.forEach(tab => {
                    tab.is_active = (tab.id == selected_tab.id)

                    if(tab.is_active) {
                        tab.$emit('isSelected')
                    }
                })
            }
        }
    }
</script>

<style scoped>
    /* .nav-link{
        border:0;
        text-transform: uppercase;
        border-bottom:4px solid silver;
        margin-right:5px;
        cursor: pointer;
    }
    .nav-link.active{
        border-bottom:4px solid #46ac4e;
    } */
</style>
